import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inspiring%20education%20abstract%20background%20with%20soft%20gradients%20in%20cream%20and%20coral%20tones%2C%20geometric%20patterns%2C%20modern%20minimalist%20design%2C%20uplifting%20learning%20atmosphere&width=1800&height=600&seq=cta-bg-learning-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开启你的学习之旅了吗？
        </h2>
        <p className="text-background-200 text-base md:text-lg mb-8 max-w-xl mx-auto">
          加入50万+学员的行列，通过成人在线课程提升你的职场竞争力，实现职业目标与个人成长。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/it-programming"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/25 whitespace-nowrap"
          >
            立即开始学习
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
          >
            免费体验课程
          </Link>
        </div>
      </div>
    </section>
  );
}